<template>
  <div>
    <frame-form component-param="crm_quote_detail" ref="frameFrom" :parent-data="parentData"></frame-form>

    <el-card shadow="never" style="margin-top: 10px">

      <el-row class="box">
        <el-col :span="9">{{ $t('quote.trade_name') }}</el-col>
        <el-col :span="1">{{ $t('quote.unit') }}</el-col>
        <el-col :span="2">{{ $t('quote.standard_price') }}</el-col>
        <el-col :span="1">{{ $t('quote.tax_rate') }}</el-col>
        <el-col :span="2">{{ $t('quote.sales_price') }}</el-col>
        <el-col :span="2">{{ $t('quote.discount_ratio') }}</el-col>
        <el-col :span="2">{{ $t('quote.number') }}</el-col>
        <el-col :span="5">{{ $t('quote.remark') }}</el-col>
      </el-row>

      <el-row v-for="item in busData.item_list" :key="item.id" class="row" :gutter="25">
        <el-col :span="9">
          {{ item.product_name }}
        </el-col>
        <el-col :span="1" class="tip">{{ item.unit }}</el-col>
        <el-col :span="2" class="tip">{{ item.market_price }}</el-col>
        <el-col :span="1" class="tip">{{ item.tax_rate }}</el-col>
        <el-col :span="2">
          <el-input v-model="item.sales_price" disabled :placeholder="$t('quote.sales_price')"></el-input>
        </el-col>
        <el-col :span="2">
          <el-input v-model="item.discount_ratio" class="w95" disabled :placeholder="$t('quote.discount_ratio')"></el-input>
        </el-col>
        <el-col :span="2">
          <el-input-number v-model="item.cnt" disabled :min="1" class="w100" :placeholder="$t('quote.number')"></el-input-number>
        </el-col>
        <el-col :span="5">
          <el-input v-model="item.remark" disabled class="w-percent-100" :placeholder="$t('quote.remark')"></el-input>
        </el-col>
      </el-row>

      <el-row style="margin-top: 15px">
        <el-col :span="9">
          <el-input type="textarea" class="quote-remark" v-model="busData.remark" disabled placeholder="报价备注" style="width: 100%"
                    :autosize="true"></el-input>
        </el-col>
      </el-row>

    </el-card>

  </div>
</template>
<script>

export default {
  name: "ChanceQuoteDetail",
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      priceTips: false,
      dialogFormVisible: false,
      busData: {
        taxAmount: '',
        totalPrice: '',
        contactId: '',
        quoteTemplateId: '',
        quoteId: '',
        chanceId: '',
        remark: '',
        item_list: []
      },
      loading: false,
    }
  },
  computed: {},
  created() {
    this.getQuoteWithDetail()
  },
  methods: {
    //获取报价数据
    async getQuoteWithDetail() {
      let params = {quote_id:this.parentData.id}
      let quoteData = await this.$http('crmQuoteService.getQuoteWithDetail', params)
      this.busData.item_list = quoteData.item_list || [];
    }
  }
}
</script>

<style scoped>
.form-item {
  width: 180px;
}

.product-head {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  margin-top: 15px;
}

.product-head span {
  margin-left: 50px;
}

.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.row {
  margin-top: 15px;
  padding: 0;
}

.row .tip {
  color: goldenrod;
  text-align: center;
  font-size: 14px;
}

.w-percent-100 {
  width: 100%;
}

.w100 {
  width: 100px;
}

.w95 {
  width: 95px;
}

.tax-amount {
  color: red;
  font-size: 18px;
}

.tax-amount span {
  margin-left: 50px;
}

.quote-remark {
  width: 100%;
  padding-right: 15px;
}

</style>